import { IMondayContext } from '@/types/response/monday/context';
import { openAuthenticate } from '@/utils/monday';
import { Button } from '@vibe/core';
import AuthenticateImage from '../assets/icons/getsignAuthenticate.svg';

const AuthenticateUI = ({
  context,
  isLoading,
  refetchProgress,
}: {
  context: IMondayContext | undefined;
  isLoading: boolean;
  refetchProgress?: () => void;
}) => {
  const openApplication = async () => {
    if (context) {
      const res = await openAuthenticate(context);
      if (res?.data?.closed) {
        refetchProgress?.();
      }
    }
  };

  return (
    <div className="flex flex-grow flex-col items-center justify-center gap-7">
      <div>
        <img src={AuthenticateImage} />
      </div>
      <div className="text-center text-base	font-bold">
        <p>
          Authenticating the app is required to give it access to board data,
          saving files and changing status on your behalf.
        </p>
      </div>
      <Button
        loading={isLoading}
        kind={Button.kinds.PRIMARY}
        onClick={openApplication}
      >
        Authenticate this app
      </Button>
    </div>
  );
};

export default AuthenticateUI;
